import { FooterLanding } from "components/FooterLanding/FooterLanding";
import { HomeLayout } from "components/Layout/HomeLayout";
import { InputSmartSearch } from "components/UIKit/InputSmartSearch";
import { GlobalContext } from "GlobalProvider";
import { useGA } from "hooks/useGA";
import { useNavigateWithQuery } from "hooks/useNavigateWithQuery";
import { useMobileResponsive, useTabletResponsive } from "hooks/useResponsive";
import { useTitle } from "hooks/useTitle";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connectService } from "services/connectService";
import { listingService } from "services/listingService";
import { systemSettingsService } from "services/systemSettingsService";
import { visitorIdService } from "services/visitoridService";

import styles from "./MobileB.module.scss";

export const mobileBPath = "/mobileb";

export const MobileB = () => {
  useTitle("TheraPass ESA");
  useGA().ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  useTitle("TheraPass ESA");
  const { isMobile } = useMobileResponsive();
  const { isTablet } = useTabletResponsive();
  const { setGlobalState } = useContext(GlobalContext);
  const [autoAssignMode, setAutoAssignMode] = useState(false);
  const [autoAssignTherpist, setAutoAssignTherapist] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const [searchUrl, setSearchUrl] = useState("/listing");
  let VisitorID = "";

  // const checkRedirect = async () => {
  //   const value = await connectService.getInterstitialMode();

  //   const url =
  //     value === "aftersearchbeforeresults" ||
  //     value === "aftersearchinplaceofresults"
  //       ? "/interstitial"
  //       : "/listing";
  //   setSearchUrl(url);
  // };

  const navigate = useNavigate();
  const queryNavigate = useNavigateWithQuery();

  visitorIdService.getVisitorID(false).then((vid) => {
    VisitorID = vid;
  });
  // eslint-disable-next-line no-console
  console.log(VisitorID);
  useEffect(() => {
    visitorIdService.trackEvent("Home", "Visit", "", "", "");
    // checkRedirect();
  }, []);
  const handleSelectPlace = (args: {
    search?: string;
    city?: string;
    state?: string;
    zip?: string;
  }) => {
    listingService.setPlaceFilter({
      ...(args?.city && { city: args.city }),
      ...(args?.search && { search: args.search }),
      ...(args?.state && { state: args.state }),
      ...(args?.zip && { zip: args.zip }),
      withoutRequest: true,
    });
  };

  useEffect(() => {
    if (!autoAssignMode) {
      systemSettingsService.get().then((res: any) => {
        if (res.auto_assign_therapist) {
          setAutoAssignTherapist(true);
        }
      });
    }
    setAutoAssignMode(true);
  }, [autoAssignMode, setAutoAssignMode]);

  const checkRedirect = async () => {
    const value: any = await systemSettingsService.get();
    if (value.auto_assign_therapist) {
      let nextPath = "";
      const query = listingService.getQuery();

      connectService.getTherapist(query, true).then((therapist: any) => {
        if (therapist["ESAStatus"] >= 1) {
          nextPath = `/connect`;
          const therapistKey = therapist["id"].toString();
          queryParams.set("therapistId", therapistKey);
          const therapistQuery = `?therapistId=${therapistKey}`;
          visitorIdService.trackEvent(
            "Home",
            "Exit",
            nextPath,
            therapistQuery,
            ""
          );
          queryNavigate(nextPath, therapistQuery);
        } else {
          navigate(searchUrl, {
            state: { withScroll: false },
          });
        }
      });
    } else {
      navigate(searchUrl, {
        state: { withScroll: false },
      });
    }
  };

  useEffect(() => {
    handleSelectPlace({ search: "" });
  }, []);
  return (
    <div>
      <HomeLayout>
        {(isTablet && (
          <div className={styles.homePage}>
            <div className={styles.content}>
              <h1
                style={{
                  marginBottom: "3rem",
                  maxWidth: "554px",
                  fontSize: "28px",
                }}
              >
                Connect Instantly to ESA Therapist
              </h1>
              <p style={{ maxWidth: "560px", fontSize: "22px" }}>
                NEW! Exclusive TheraPass platform lets you choose your ESA
                therapist as well as how you want to get your ESA: text message,
                phone or video.
              </p>

              <div className="row">
                <div className="col-xxs-6">
                  <ul
                    style={{
                      marginTop: "20px",
                      marginLeft: "-14px",
                      fontSize: "20px",
                    }}
                  >
                    <li style={{ marginTop: "1.25rem" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 12 55 45"
                        fill="none"
                        x="12"
                        y="15"
                        preserveAspectRatio="xMidYMid meet"
                        style={{ float: "left" }}
                      >
                        <g filter="url(#filter0_d_45_29)">
                          <rect
                            x="20"
                            y="10"
                            width="24"
                            height="24"
                            rx="12"
                            fill="#3CEAC1"
                            shape-rendering="crispEdges"
                          />
                          <path
                            d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_45_29"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="10" />
                            <feGaussianBlur stdDeviation="10" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_45_29"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_45_29"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                      <div style={{ textAlign: "left" }}>
                        <div>
                          No waiting - instant ESA letter delivery (PDF)
                        </div>
                      </div>
                    </li>
                    <li style={{ marginTop: "1.25rem" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 12 55 45"
                        fill="none"
                        x="12"
                        y="15"
                        preserveAspectRatio="xMidYMid meet"
                        style={{ float: "left" }}
                      >
                        <g filter="url(#filter0_d_45_29)">
                          <rect
                            x="20"
                            y="10"
                            width="24"
                            height="24"
                            rx="12"
                            fill="#3CEAC1"
                            shape-rendering="crispEdges"
                          />
                          <path
                            d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_45_29"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="10" />
                            <feGaussianBlur stdDeviation="10" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_45_29"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_45_29"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                      <div style={{ textAlign: "left" }}>
                        <div>State licensed therapist</div>
                      </div>
                    </li>
                    <li style={{ marginTop: "1.25rem" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 12 55 45"
                        fill="none"
                        x="12"
                        y="15"
                        preserveAspectRatio="xMidYMid meet"
                        style={{ float: "left" }}
                      >
                        <g filter="url(#filter0_d_45_29)">
                          <rect
                            x="20"
                            y="10"
                            width="24"
                            height="24"
                            rx="12"
                            fill="#3CEAC1"
                            shape-rendering="crispEdges"
                          />
                          <path
                            d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_45_29"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="10" />
                            <feGaussianBlur stdDeviation="10" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_45_29"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_45_29"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                      <div style={{ textAlign: "left" }}>
                        <div>Get your ESA by text message, phone or video</div>
                      </div>
                    </li>
                    <li style={{ marginTop: "1.25rem" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 12 55 45"
                        fill="none"
                        x="12"
                        y="15"
                        preserveAspectRatio="xMidYMid meet"
                        style={{ float: "left" }}
                      >
                        <g filter="url(#filter0_d_45_29)">
                          <rect
                            x="20"
                            y="10"
                            width="24"
                            height="24"
                            rx="12"
                            fill="#3CEAC1"
                            shape-rendering="crispEdges"
                          />
                          <path
                            d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_45_29"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="10" />
                            <feGaussianBlur stdDeviation="10" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_45_29"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_45_29"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                      <div style={{ textAlign: "left" }}>
                        <div>No breed restrictions</div>
                      </div>
                    </li>
                    <li style={{ marginTop: "1.25rem" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 12 55 45"
                        fill="none"
                        x="12"
                        y="15"
                        preserveAspectRatio="xMidYMid meet"
                        style={{ float: "left" }}
                      >
                        <g filter="url(#filter0_d_45_29)">
                          <rect
                            x="20"
                            y="10"
                            width="24"
                            height="24"
                            rx="12"
                            fill="#3CEAC1"
                            shape-rendering="crispEdges"
                          />
                          <path
                            d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_45_29"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="10" />
                            <feGaussianBlur stdDeviation="10" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_45_29"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_45_29"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                      <div style={{ textAlign: "left" }}>
                        <div>No extra charge for multiple pets</div>
                      </div>
                    </li>
                    <li style={{ marginTop: "1.25rem" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 12 55 45"
                        fill="none"
                        x="12"
                        y="15"
                        preserveAspectRatio="xMidYMid meet"
                        style={{ float: "left" }}
                      >
                        <g filter="url(#filter0_d_45_29)">
                          <rect
                            x="20"
                            y="10"
                            width="24"
                            height="24"
                            rx="12"
                            fill="#3CEAC1"
                            shape-rendering="crispEdges"
                          />
                          <path
                            d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_45_29"
                            x="0"
                            y="0"
                            width="64"
                            height="64"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="10" />
                            <feGaussianBlur stdDeviation="10" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_45_29"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_45_29"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                      <div style={{ textAlign: "left" }}>
                        <div>Guaranteed landlord acceptance or money back</div>
                      </div>
                    </li>
                  </ul>
                  <div className={styles.search} style={{ marginTop: "20px" }}>
                    <InputSmartSearch
                      placeholder="Enter your City / Zip"
                      onSelectPlace={handleSelectPlace}
                      maxLength={200}
                      max={200}
                      withButton
                      buttonClass={styles.bottomBtn}
                      className={styles.searchInput}
                      buttonLabel="CONNECT - GET ESA NOW"
                      onButtonClick={() => {
                        setGlobalState({ prevPage: window.location.pathname });
                        checkRedirect();
                      }}
                    />
                  </div>
                </div>
                <div className="col-xxs-6">
                  <img
                    src="https://therapass-esa-assets.s3.amazonaws.com/esa-therapass-vertical-v2.gif"
                    alt=""
                    width="300"
                  />
                </div>
              </div>
            </div>
          </div>
        )) ||
          (isMobile && (
            <div className={styles.homePage}>
              <div className={styles.content}>
                <h1
                  style={{
                    marginBottom: "3rem",
                    maxWidth: "884px",
                    fontSize: "24px",
                  }}
                >
                  Connect Instantly to ESA Therapist
                </h1>
                <p style={{ fontSize: "16px" }}>
                  Only TheraPass lets you choose your therapist and the way you
                  want to connect for your ESA letter: text message, phone,
                  video, and even mobile video!
                </p>
                <ul
                  style={{
                    marginTop: "20px",
                    marginLeft: "-14px",
                    fontSize: "14px",
                  }}
                >
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>No waiting - instant ESA letter delivery (PDF)</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>State licensed therapist</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>Get your ESA by text message, phone or video</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>No breed restrictions</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>No extra charge for multiple pets</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>Guaranteed landlord acceptance or money back</div>
                    </div>
                  </li>
                </ul>
                <div className={styles.search} style={{ marginTop: "20px" }}>
                  <InputSmartSearch
                    placeholder="Enter your City / Zip"
                    onSelectPlace={handleSelectPlace}
                    maxLength={200}
                    max={200}
                    withButton
                    buttonClass={styles.bottomBtn}
                    className={styles.searchInput}
                    buttonLabel="CONNECT - GET ESA NOW"
                    onButtonClick={() => {
                      setGlobalState({ prevPage: window.location.pathname });
                      checkRedirect();
                    }}
                  />
                </div>
              </div>
            </div>
          )) || (
            <div className={styles.homePage}>
              <div className={styles.content}>
                <h1 style={{ marginBottom: "3rem", maxWidth: "884px" }}>
                  Connect Instantly to ESA Therapist
                </h1>
                <p>
                  Only TheraPass lets you choose your therapist and the way you
                  want to connect for your ESA letter: text message, phone,
                  video, and even mobile video!
                </p>
                <ul style={{ marginTop: "20px", marginLeft: "-14px" }}>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>No waiting - instant ESA letter delivery (PDF)</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>State licensed therapist</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>Get your ESA by text message, phone or video</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>No breed restrictions</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>No extra charge for multiple pets</div>
                    </div>
                  </li>
                  <li style={{ marginTop: "1.25rem" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 12 55 45"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ float: "left" }}
                    >
                      <g filter="url(#filter0_d_45_29)">
                        <rect
                          x="20"
                          y="10"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#3CEAC1"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M27.4038 21.6567L30.9393 25.1923L36.5962 19.5354"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_45_29"
                          x="0"
                          y="0"
                          width="64"
                          height="64"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="10" />
                          <feGaussianBlur stdDeviation="10" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.587969 0 0 0 0 0.653866 0 0 0 0 0.8875 0 0 0 0.1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_45_29"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_45_29"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div style={{ textAlign: "left" }}>
                      <div>Guaranteed landlord acceptance or money back</div>
                    </div>
                  </li>
                </ul>
                <div className={styles.search} style={{ marginTop: "20px" }}>
                  <InputSmartSearch
                    placeholder="Enter your City / Zip"
                    onSelectPlace={handleSelectPlace}
                    maxLength={200}
                    max={200}
                    withButton
                    buttonClass={styles.bottomBtn}
                    className={styles.searchInput}
                    buttonLabel="CONNECT - GET ESA NOW"
                    onButtonClick={() => {
                      setGlobalState({ prevPage: window.location.pathname });
                      checkRedirect();
                    }}
                  />
                </div>
              </div>
              <img
                src="https://therapass-esa-assets.s3.amazonaws.com/esa-therapass-vertical-v2.gif"
                alt=""
                width="300"
              />
            </div>
          )}
      </HomeLayout>
      {(isTablet && (
        <div
          className="container"
          style={{ maxWidth: "100%", backgroundColor: "#21816A" }}
        >
          <div className="row" style={{ width: "100%", color: "white" }}>
            <div className="col-xxs-3" style={{}}>
              <div style={{ marginTop: "1.25rem" }}>
                <div style={{ textAlign: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                  >
                    <circle
                      cx="30"
                      cy="30"
                      r="29"
                      stroke="#E9EBF8"
                      stroke-width="2"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="38"
                      height="38"
                      viewBox="0 0 38 38"
                      fill="none"
                      x="11"
                      y="11"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path
                        d="M5.28 5C3.988 5 3 5.988 3 7.28V9.56H34.92V7.28C34.92 5.988 33.932 5 32.64 5H5.28ZM6.04 6.52C6.45952 6.52 6.8 6.86048 6.8 7.28C6.8 7.69952 6.45952 8.04 6.04 8.04C5.62048 8.04 5.28 7.69952 5.28 7.28C5.28 6.86048 5.62048 6.52 6.04 6.52ZM8.32 6.52C8.73952 6.52 9.08 6.86048 9.08 7.28C9.08 7.69952 8.73952 8.04 8.32 8.04C7.90048 8.04 7.56 7.69952 7.56 7.28C7.56 6.86048 7.90048 6.52 8.32 6.52ZM10.6 6.52C11.0195 6.52 11.36 6.86048 11.36 7.28C11.36 7.69952 11.0195 8.04 10.6 8.04C10.1805 8.04 9.84 7.69952 9.84 7.28C9.84 6.86048 10.1805 6.52 10.6 6.52ZM3 11.08V30.08C3 31.3393 4.02068 32.36 5.28 32.36H32.64C33.8993 32.36 34.92 31.3393 34.92 30.08V11.08H3ZM28.2225 14.8948C28.3196 14.9133 28.4153 14.9506 28.503 15.0091C28.8519 15.2402 28.9457 15.7127 28.7123 16.0616L25.6723 20.6216C25.6495 20.6558 25.6218 20.6832 25.5952 20.7121C25.5876 20.7197 25.5849 20.7297 25.5773 20.7373C25.5735 20.7411 25.5693 20.7424 25.5655 20.7463C25.5009 20.8086 25.4256 20.8553 25.3458 20.8902C25.3283 20.8978 25.3121 20.9049 25.2938 20.911C25.2125 20.9399 25.1281 20.96 25.0415 20.96H25.04H25.0385C24.9526 20.96 24.8675 20.9407 24.7847 20.911C24.7588 20.9019 24.7363 20.889 24.712 20.8769C24.6808 20.8617 24.6481 20.8513 24.6184 20.8323C24.5964 20.8179 24.5862 20.7964 24.5665 20.7804C24.5467 20.7644 24.5224 20.7563 24.5041 20.7373L22.2241 18.4573C21.927 18.1602 21.927 17.6813 22.2241 17.3841C22.5213 17.087 23.0002 17.087 23.2973 17.3841L24.9227 19.008L27.4491 15.2199C27.6236 14.9583 27.9312 14.8394 28.2225 14.8948ZM9.84 17.16H18.2C18.6203 17.16 18.96 17.5005 18.96 17.92C18.96 18.3395 18.6203 18.68 18.2 18.68H9.84C9.41972 18.68 9.08 18.3395 9.08 17.92C9.08 17.5005 9.41972 17.16 9.84 17.16ZM28.2225 22.4948C28.3196 22.5134 28.4153 22.5508 28.503 22.6091C28.8519 22.8409 28.9457 23.312 28.7123 23.6616L25.6723 28.2216C25.6495 28.2558 25.6218 28.2832 25.5952 28.3121C25.5876 28.3197 25.5849 28.3297 25.5773 28.3373C25.5735 28.3411 25.5693 28.3424 25.5655 28.3463C25.5009 28.4086 25.4256 28.4553 25.3458 28.4902C25.3283 28.4978 25.3121 28.5049 25.2938 28.511C25.2125 28.5399 25.1281 28.56 25.0415 28.56H25.04H25.0385C24.9526 28.56 24.8675 28.5407 24.7847 28.511C24.7588 28.5019 24.7363 28.489 24.712 28.4769C24.6808 28.4617 24.6481 28.4513 24.6184 28.4323C24.5964 28.4179 24.5862 28.3964 24.5665 28.3804C24.5467 28.3644 24.5224 28.3563 24.5041 28.3373L22.2241 26.0573C21.927 25.7602 21.927 25.2813 22.2241 24.9841C22.5213 24.687 23.0002 24.687 23.2973 24.9841L24.9227 26.608L27.4491 22.8199C27.6236 22.5577 27.9312 22.4393 28.2225 22.4948ZM9.84 24.76H18.2C18.6203 24.76 18.96 25.0997 18.96 25.52C18.96 25.9403 18.6203 26.28 18.2 26.28H9.84C9.41972 26.28 9.08 25.9403 9.08 25.52C9.08 25.0997 9.41972 24.76 9.84 24.76Z"
                        fill="#E9EBF8"
                      />
                    </svg>
                  </svg>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div>2 Million+ Mental Health Assessments</div>
                </div>
              </div>
            </div>
            <div className="col-xxs-3" style={{}}>
              <div style={{ marginTop: "1.25rem" }}>
                <div style={{ textAlign: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                  >
                    <circle
                      cx="30"
                      cy="30"
                      r="29"
                      stroke="#E9EBF8"
                      stroke-width="2"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="35"
                      viewBox="0 0 30 35"
                      fill="none"
                      x="15"
                      y="11"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <g clip-path="url(#clip0_138_526)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M6.42735 2.14247C6.42735 0.957413 7.38476 0 8.56982 0C9.75488 0 10.7123 0.957413 10.7123 2.14247V4.28496H19.2822V2.14247C19.2822 0.957413 20.2396 0 21.4247 0C22.6097 0 23.5672 0.957413 23.5672 2.14247V4.28496H26.7809C28.5551 4.28496 29.9946 5.72442 29.9946 7.49867V10.7124H-0.00012207V7.49867C-0.00012207 5.72442 1.43935 4.28496 3.21359 4.28496H6.4273V2.14247H6.42735ZM29.9946 12.8548V31.0658C29.9946 32.8401 28.5551 34.2795 26.7809 34.2795H3.21364C1.4394 34.2795 -7.38646e-05 32.8401 -7.38646e-05 31.0658V12.8548H29.9946ZM12.6232 30.0938C12.7893 30.0938 12.9044 30.0189 12.9687 29.8689L13.4909 28.6155H16.2226L16.7448 29.8689C16.8091 30.0189 16.9243 30.0938 17.0903 30.0938C17.2028 30.0938 17.2911 30.059 17.3554 29.9894C17.4197 29.9198 17.4518 29.8341 17.4518 29.7323C17.4518 29.6894 17.4384 29.6359 17.4117 29.5716L15.3629 24.735C15.3254 24.6493 15.2692 24.573 15.1942 24.506C15.1192 24.439 15.0201 24.4056 14.8969 24.4056H14.8166C14.6988 24.4056 14.601 24.439 14.5233 24.506C14.4457 24.573 14.3881 24.6493 14.3506 24.735L12.3019 29.5716C12.2751 29.6359 12.2617 29.6894 12.2617 29.7323C12.2617 29.8341 12.2938 29.9198 12.3581 29.9894C12.4224 30.059 12.5107 30.0938 12.6232 30.0938ZM13.7721 27.9487L14.8568 25.3375L15.9414 27.9487H13.7721ZM7.87497 30.0537H11.0967C11.1931 30.0537 11.2748 30.0215 11.3418 29.9573C11.4087 29.893 11.4422 29.8126 11.4422 29.7162C11.4422 29.6198 11.4087 29.5381 11.3418 29.4712C11.2748 29.4042 11.1931 29.3708 11.0967 29.3708H8.24454V27.5871H10.8075C10.9039 27.5871 10.9856 27.555 11.0525 27.4907C11.1195 27.4265 11.153 27.3461 11.153 27.2497C11.153 27.1533 11.1195 27.0716 11.0525 27.0047C10.9856 26.9377 10.9039 26.9042 10.8075 26.9042H8.24454V25.1287H11.0967C11.1931 25.1287 11.2748 25.0965 11.3418 25.0322C11.4087 24.968 11.4422 24.8876 11.4422 24.7912C11.4422 24.6948 11.4087 24.6131 11.3418 24.5462C11.2748 24.4792 11.1931 24.4457 11.0967 24.4457H7.87497C7.7732 24.4457 7.68751 24.4819 7.61787 24.5542C7.54824 24.6265 7.51342 24.7136 7.51342 24.8153V29.6921C7.51342 29.7939 7.54824 29.8796 7.61787 29.9492C7.68751 30.0189 7.7732 30.0537 7.87497 30.0537ZM4.17116 30.0938C4.27294 30.0938 4.35864 30.059 4.42826 29.9894C4.4979 29.9198 4.53271 29.8341 4.53271 29.7323V27.6836L6.46093 24.9921C6.50379 24.9224 6.52521 24.8501 6.52521 24.7752C6.53057 24.6734 6.49977 24.5863 6.43281 24.514C6.36587 24.4417 6.27883 24.4056 6.1717 24.4056C6.0378 24.4056 5.93067 24.4672 5.85033 24.5904L4.17116 27.0328L2.492 24.5904C2.41166 24.4672 2.30454 24.4056 2.17063 24.4056C2.06887 24.4056 1.98451 24.4417 1.91755 24.514C1.85061 24.5863 1.81712 24.6734 1.81712 24.7752C1.81712 24.8501 1.83856 24.9224 1.88139 24.9921L3.80159 27.6836V29.7323C3.80159 29.8341 3.83774 29.9198 3.91005 29.9894C3.98236 30.059 4.0694 30.0938 4.17116 30.0938ZM18.9944 30.0938C19.0962 30.0938 19.1832 30.059 19.2555 29.9894C19.3278 29.9198 19.364 29.8341 19.364 29.7323V27.8683H21.0271C21.3324 27.8683 21.5694 27.9259 21.7381 28.0411C21.9068 28.1562 22.0287 28.3022 22.1037 28.479C22.1787 28.6557 22.2255 28.8351 22.2443 29.0173C22.263 29.1994 22.2724 29.3574 22.2724 29.4913V29.7323C22.2724 29.8394 22.3059 29.9265 22.3728 29.9934C22.4398 30.0604 22.5295 30.0938 22.642 30.0938C22.7438 30.0938 22.8294 30.059 22.8991 29.9894C22.9687 29.9198 23.0035 29.8341 23.0035 29.7323V29.3627C23.0035 29.2502 22.9928 29.1043 22.9714 28.9249C22.95 28.7454 22.9058 28.5593 22.8388 28.3665C22.7719 28.1737 22.6714 28.0009 22.5375 27.8483C22.4036 27.6956 22.2242 27.5898 21.9992 27.5309C22.3527 27.4077 22.6165 27.2122 22.7906 26.9444C22.9647 26.6766 23.0517 26.3874 23.0517 26.0767C23.0517 25.7661 22.9754 25.4889 22.8227 25.2452C22.6701 25.0014 22.4331 24.8073 22.1117 24.6627C21.7903 24.5181 21.3752 24.4457 20.8664 24.4457H18.9944C18.8926 24.4457 18.807 24.4819 18.7373 24.5542C18.6677 24.6265 18.6329 24.7136 18.6329 24.8153V29.7323C18.6329 29.8341 18.6677 29.9198 18.7373 29.9894C18.807 30.059 18.8926 30.0938 18.9944 30.0938ZM19.364 27.1774V25.1367H20.778C21.1744 25.1367 21.485 25.1782 21.71 25.2612C21.935 25.3442 22.093 25.4607 22.184 25.6107C22.2751 25.7607 22.3206 25.9348 22.3206 26.1329C22.3206 26.4757 22.1827 26.7355 21.9068 26.9123C21.631 27.089 21.2681 27.1774 20.8182 27.1774H19.364ZM26.1208 30.134C26.5386 30.134 26.9015 30.0671 27.2095 29.9332C27.5175 29.7993 27.7558 29.6131 27.9245 29.3748C28.0932 29.1364 28.1776 28.8673 28.1776 28.5673C28.1776 28.262 28.116 28.0143 27.9928 27.8242C27.8696 27.634 27.7063 27.4814 27.5027 27.3662C27.2992 27.251 27.0769 27.1586 26.8359 27.089C26.5948 27.0194 26.3538 26.9565 26.1128 26.9002C25.8718 26.844 25.6495 26.781 25.4459 26.7114C25.2424 26.6418 25.079 26.548 24.9558 26.4302C24.8327 26.3124 24.7711 26.1544 24.7711 25.9562C24.7711 25.6562 24.9076 25.4286 25.1808 25.2733C25.454 25.1179 25.7941 25.0403 26.2012 25.0403C26.4476 25.0403 26.6792 25.0604 26.8961 25.1005C27.1131 25.1407 27.3126 25.1929 27.4947 25.2572C27.5161 25.2626 27.5375 25.2693 27.559 25.2773C27.5804 25.2853 27.6018 25.2893 27.6232 25.2893C27.725 25.2893 27.804 25.2532 27.8602 25.1809C27.9165 25.1086 27.9446 25.0322 27.9446 24.9519C27.9446 24.8555 27.9218 24.7832 27.8763 24.735C27.8308 24.6868 27.7786 24.652 27.7196 24.6305C27.5054 24.5502 27.2644 24.4859 26.9966 24.4377C26.7288 24.3895 26.4368 24.3654 26.1208 24.3654C25.6709 24.3654 25.2906 24.4404 24.9799 24.5904C24.6693 24.7403 24.435 24.9399 24.277 25.1889C24.1189 25.438 24.0399 25.7125 24.0399 26.0124C24.0399 26.2963 24.1015 26.5306 24.2247 26.7154C24.3479 26.9002 24.5113 27.0515 24.7148 27.1694C24.9184 27.2872 25.1406 27.3823 25.3817 27.4546C25.6227 27.5269 25.8651 27.5925 26.1088 27.6514C26.3525 27.7103 26.5761 27.7746 26.7796 27.8442C26.9832 27.9139 27.1465 28.0009 27.2697 28.1054C27.3929 28.2098 27.4545 28.3477 27.4545 28.5191C27.4545 28.7494 27.3929 28.9329 27.2697 29.0695C27.1465 29.2061 26.9792 29.3025 26.7676 29.3587C26.556 29.4149 26.3163 29.4431 26.0485 29.4431C25.7057 29.4431 25.4018 29.4082 25.1366 29.3386C24.8715 29.269 24.6479 29.194 24.4658 29.1137C24.4176 29.0922 24.3667 29.0815 24.3131 29.0815C24.2113 29.0815 24.131 29.115 24.0721 29.182C24.0132 29.2489 23.9837 29.3279 23.9837 29.419C23.9837 29.4886 24.0065 29.5542 24.052 29.6158C24.0975 29.6774 24.1498 29.7216 24.2087 29.7484C24.4443 29.8501 24.7215 29.9399 25.0402 30.0175C25.3589 30.0952 25.7191 30.134 26.1208 30.134ZM15.2143 22.0997C15.6267 22.0997 15.9802 22.0181 16.2748 21.8547C16.5694 21.6913 16.797 21.4717 16.9577 21.1959C17.1184 20.92 17.1987 20.6134 17.1987 20.276C17.1987 19.8903 17.1211 19.5569 16.9658 19.2757C16.8104 18.9945 16.5948 18.7762 16.319 18.6209C16.0432 18.4656 15.7231 18.3879 15.3589 18.3879C14.9197 18.3879 14.5689 18.4629 14.3064 18.6129C14.044 18.7628 13.8458 18.9235 13.7119 19.0949C13.7226 18.9128 13.752 18.7052 13.8002 18.4723C13.8485 18.2393 13.9328 18.013 14.0533 17.7934C14.1738 17.5738 14.3426 17.393 14.5595 17.251C14.7764 17.1091 15.0563 17.0381 15.3991 17.0381C15.6187 17.0381 15.8182 17.0609 15.9976 17.1064C16.1771 17.152 16.3337 17.2069 16.4676 17.2711C16.5105 17.2872 16.556 17.2952 16.6042 17.2952C16.706 17.2952 16.7863 17.2618 16.8452 17.1948C16.9042 17.1278 16.9336 17.0515 16.9336 16.9658C16.9336 16.8266 16.8774 16.7302 16.7649 16.6766C16.6042 16.5909 16.4101 16.5119 16.1824 16.4396C15.9548 16.3673 15.6749 16.3311 15.3428 16.3311C14.9036 16.3311 14.5341 16.4208 14.2341 16.6003C13.9342 16.7797 13.6945 17.0154 13.515 17.3073C13.3356 17.5992 13.2071 17.9125 13.1294 18.2473C13.0517 18.5821 13.0129 18.9074 13.0129 19.2235C13.0129 19.4431 13.0263 19.6827 13.0531 19.9425C13.0798 20.2023 13.1348 20.4581 13.2178 20.7098C13.3008 20.9615 13.4226 21.1932 13.5833 21.4048C13.744 21.6163 13.9569 21.7851 14.222 21.9109C14.4872 22.0368 14.8179 22.0997 15.2143 22.0997ZM15.2223 21.4168C14.8902 21.4168 14.6224 21.3472 14.4189 21.2079C14.2154 21.0687 14.0627 20.8866 13.9609 20.6616C13.8592 20.4366 13.7895 20.1956 13.752 19.9385C13.811 19.8314 13.898 19.7095 14.0132 19.573C14.1283 19.4364 14.2877 19.3159 14.4912 19.2114C14.6947 19.107 14.9545 19.0547 15.2705 19.0547C15.6722 19.0547 15.9722 19.1672 16.1704 19.3922C16.3686 19.6171 16.4676 19.9064 16.4676 20.2599C16.4676 20.4634 16.4168 20.6536 16.315 20.8303C16.2132 21.0071 16.0699 21.149 15.8851 21.2561C15.7004 21.3633 15.4794 21.4168 15.2223 21.4168Z"
                          fill="#E9EBF8"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_138_526">
                          <rect width="30" height="34.2903" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </svg>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div>6 years in Business</div>
                </div>
              </div>
            </div>
            <div className="col-xxs-3" style={{}}>
              <div style={{ marginTop: "1.25rem" }}>
                <div style={{ textAlign: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                  >
                    <circle
                      cx="30"
                      cy="30"
                      r="29"
                      stroke="#E9EBF8"
                      stroke-width="2"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      x="12"
                      y="10"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path
                        d="M22.0359 2.31329C23.8641 2.67891 25.0523 4.45782 24.6867 6.28594L24.525 7.0875C24.1523 8.96485 23.4633 10.7508 22.5 12.375H32.625C34.4883 12.375 36 13.8867 36 15.75C36 17.0508 35.2617 18.1828 34.1789 18.7453C34.9453 19.3641 35.4375 20.3133 35.4375 21.375C35.4375 23.0203 34.2563 24.3914 32.7023 24.6867C33.0117 25.2 33.1875 25.7977 33.1875 26.4375C33.1875 27.9352 32.2102 29.2078 30.8602 29.6438C30.9094 29.8758 30.9375 30.1219 30.9375 30.375C30.9375 32.2383 29.4258 33.75 27.5625 33.75H20.707C19.3711 33.75 18.0703 33.3563 16.9594 32.618L14.2523 30.8109C12.375 29.5594 11.25 27.45 11.25 25.193V17.3742C11.25 15.3211 12.1852 13.3875 13.7812 12.1008L14.3016 11.6859C16.1648 10.1953 17.4375 8.1 17.9016 5.76563L18.0633 4.96407C18.4289 3.13594 20.2078 1.94766 22.0359 2.31329ZM2.25 13.5H6.75C7.99453 13.5 9 14.5055 9 15.75V31.5C9 32.7445 7.99453 33.75 6.75 33.75H2.25C1.00547 33.75 0 32.7445 0 31.5V15.75C0 14.5055 1.00547 13.5 2.25 13.5Z"
                        fill="#E9EBF8"
                      />
                    </svg>
                  </svg>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div>200K+ Satisfied Customers</div>
                </div>
              </div>
            </div>
            <div className="col-xxs-3" style={{}}>
              <div style={{ marginTop: "1.25rem" }}>
                <div style={{ textAlign: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                  >
                    <circle
                      cx="30"
                      cy="30"
                      r="29"
                      stroke="#E9EBF8"
                      stroke-width="2"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="29"
                      viewBox="0 0 36 29"
                      fill="none"
                      x="12"
                      y="15"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <g clip-path="url(#clip0_45_199)">
                        <path
                          d="M8.1 0C9.29347 0 10.4381 0.474106 11.282 1.31802C12.1259 2.16193 12.6 3.30653 12.6 4.5C12.6 5.69347 12.1259 6.83807 11.282 7.68198C10.4381 8.52589 9.29347 9 8.1 9C6.90653 9 5.76193 8.52589 4.91802 7.68198C4.07411 6.83807 3.6 5.69347 3.6 4.5C3.6 3.30653 4.07411 2.16193 4.91802 1.31802C5.76193 0.474106 6.90653 0 8.1 0ZM28.8 0C29.9935 0 31.1381 0.474106 31.982 1.31802C32.8259 2.16193 33.3 3.30653 33.3 4.5C33.3 5.69347 32.8259 6.83807 31.982 7.68198C31.1381 8.52589 29.9935 9 28.8 9C27.6065 9 26.4619 8.52589 25.618 7.68198C24.7741 6.83807 24.3 5.69347 24.3 4.5C24.3 3.30653 24.7741 2.16193 25.618 1.31802C26.4619 0.474106 27.6065 0 28.8 0ZM0 16.8019C0 13.4888 2.68875 10.8 6.00187 10.8H8.40375C9.29812 10.8 10.1475 10.9969 10.9125 11.3456C10.8394 11.7506 10.8056 12.1725 10.8056 12.6C10.8056 14.7487 11.7506 16.6781 13.2412 18H1.19812C0.54 18 0 17.46 0 16.8019ZM22.7981 18H22.7587C24.255 16.6781 25.1944 14.7487 25.1944 12.6C25.1944 12.1725 25.155 11.7562 25.0875 11.3456C25.8525 10.9912 26.7019 10.8 27.5963 10.8H29.9981C33.3112 10.8 36 13.4888 36 16.8019C36 17.4656 35.46 18 34.8019 18H22.7981ZM12.6 12.6C12.6 11.1678 13.1689 9.79432 14.1816 8.78162C15.1943 7.76893 16.5678 7.2 18 7.2C19.4322 7.2 20.8057 7.76893 21.8184 8.78162C22.8311 9.79432 23.4 11.1678 23.4 12.6C23.4 14.0322 22.8311 15.4057 21.8184 16.4184C20.8057 17.4311 19.4322 18 18 18C16.5678 18 15.1943 17.4311 14.1816 16.4184C13.1689 15.4057 12.6 14.0322 12.6 12.6ZM7.2 27.2981C7.2 23.1581 10.5581 19.8 14.6981 19.8H21.3019C25.4419 19.8 28.8 23.1581 28.8 27.2981C28.8 28.125 28.1306 28.8 27.2981 28.8H8.70187C7.875 28.8 7.2 28.1306 7.2 27.2981Z"
                          fill="#E9EBF8"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_45_199">
                          <rect width="36" height="28.8" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </svg>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div>600k+ Therapist & Mental Health Professionals</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )) ||
        (isMobile && (
          <div
            style={{
              backgroundImage: "linear-gradient(to right, #E5FBF8, #ECFDF9)",
              maxWidth: "100%",
              width: "100%",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src="https://therapass-esa-assets.s3.amazonaws.com/esa-therapass-vertical-v2.gif"
                alt=""
                width="300"
              />
            </div>

            <div
              style={{
                backgroundImage: "linear-gradient(to right, #E5FBF8, #ECFDF9)",
                maxWidth: "100%",
                width: "100%",
              }}
            >
              <div className="container">
                <h1
                  style={{
                    marginBottom: "1rem",
                    fontSize: "24px",
                    paddingTop: "2rem",
                  }}
                >
                  Why Therapass?
                </h1>
                <div
                  className="row"
                  style={{
                    minWidth: "100%",
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  <div className="col-6" style={{}}>
                    <div
                      style={{
                        borderRadius: "10px",
                        padding: "10px",
                        border: "1px solid #21816A",
                        backgroundColor: "#FFF",
                        height: "177px",
                      }}
                    >
                      <div style={{ textAlign: "left", paddingTop: "1rem" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <circle cx="20" cy="20" r="19.5" stroke="#21816A" />
                          <path
                            d="M10.5714 11C9.68095 11 9 11.681 9 12.5714V14.1429H31V12.5714C31 11.681 30.319 11 29.4286 11H10.5714ZM11.0952 12.0476C11.3844 12.0476 11.619 12.2823 11.619 12.5714C11.619 12.8606 11.3844 13.0952 11.0952 13.0952C10.8061 13.0952 10.5714 12.8606 10.5714 12.5714C10.5714 12.2823 10.8061 12.0476 11.0952 12.0476ZM12.6667 12.0476C12.9558 12.0476 13.1905 12.2823 13.1905 12.5714C13.1905 12.8606 12.9558 13.0952 12.6667 13.0952C12.3775 13.0952 12.1429 12.8606 12.1429 12.5714C12.1429 12.2823 12.3775 12.0476 12.6667 12.0476ZM14.2381 12.0476C14.5272 12.0476 14.7619 12.2823 14.7619 12.5714C14.7619 12.8606 14.5272 13.0952 14.2381 13.0952C13.949 13.0952 13.7143 12.8606 13.7143 12.5714C13.7143 12.2823 13.949 12.0476 14.2381 12.0476ZM9 15.1905V28.2857C9 29.1537 9.70348 29.8571 10.5714 29.8571H29.4286C30.2965 29.8571 31 29.1537 31 28.2857V15.1905H9ZM26.3839 17.8198C26.4509 17.8325 26.5168 17.8582 26.5773 17.8985C26.8177 18.0578 26.8824 18.3835 26.7215 18.6239L24.6263 21.7667C24.6106 21.7903 24.5914 21.8092 24.5731 21.8291C24.5679 21.8344 24.5661 21.8413 24.5608 21.8465C24.5582 21.8492 24.5553 21.8501 24.5526 21.8527C24.5081 21.8956 24.4562 21.9278 24.4012 21.9519C24.3892 21.9572 24.378 21.962 24.3654 21.9662C24.3094 21.9861 24.2512 22 24.1915 22H24.1905H24.1895C24.1303 22 24.0716 21.9867 24.0145 21.9662C23.9967 21.96 23.9811 21.9511 23.9644 21.9427C23.9429 21.9322 23.9204 21.9251 23.8999 21.912C23.8847 21.9021 23.8777 21.8872 23.8641 21.8762C23.8505 21.8652 23.8337 21.8596 23.8212 21.8465L22.2497 20.2751C22.0449 20.0703 22.0449 19.7402 22.2497 19.5354C22.4545 19.3306 22.7846 19.3306 22.9894 19.5354L24.1097 20.6547L25.8509 18.0438C25.9711 17.8635 26.1831 17.7815 26.3839 17.8198ZM13.7143 19.381H19.4762C19.7659 19.381 20 19.6156 20 19.9048C20 20.1939 19.7659 20.4286 19.4762 20.4286H13.7143C13.4246 20.4286 13.1905 20.1939 13.1905 19.9048C13.1905 19.6156 13.4246 19.381 13.7143 19.381ZM26.3839 23.0578C26.4509 23.0706 26.5168 23.0964 26.5773 23.1366C26.8177 23.2964 26.8824 23.621 26.7215 23.862L24.6263 27.0048C24.6106 27.0284 24.5914 27.0473 24.5731 27.0672C24.5679 27.0725 24.5661 27.0794 24.5608 27.0846C24.5582 27.0873 24.5553 27.0882 24.5526 27.0908C24.5081 27.1337 24.4562 27.1659 24.4012 27.19C24.3892 27.1952 24.378 27.2001 24.3654 27.2043C24.3094 27.2242 24.2512 27.2381 24.1915 27.2381H24.1905H24.1895C24.1303 27.2381 24.0716 27.2248 24.0145 27.2043C23.9967 27.198 23.9811 27.1892 23.9644 27.1808C23.9429 27.1703 23.9204 27.1632 23.8999 27.1501C23.8847 27.1402 23.8777 27.1253 23.8641 27.1143C23.8505 27.1033 23.8337 27.0977 23.8212 27.0846L22.2497 25.5132C22.0449 25.3084 22.0449 24.9783 22.2497 24.7735C22.4545 24.5687 22.7846 24.5687 22.9894 24.7735L24.1097 25.8928L25.8509 23.2819C25.9711 23.1012 26.1831 23.0196 26.3839 23.0578ZM13.7143 24.619H19.4762C19.7659 24.619 20 24.8532 20 25.1429C20 25.4325 19.7659 25.6667 19.4762 25.6667H13.7143C13.4246 25.6667 13.1905 25.4325 13.1905 25.1429C13.1905 24.8532 13.4246 24.619 13.7143 24.619Z"
                            fill="#21816A"
                          />
                        </svg>
                        <div style={{ color: "#1F342F" }}>
                          <div style={{ fontSize: "20px" }}>2 Million+</div>
                          <div style={{ fontSize: "14px" }}>
                            Mental Health Assessments
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{}}>
                    <div
                      style={{
                        borderRadius: "10px",
                        padding: "10px",
                        border: "1px solid #21816A",
                        backgroundColor: "#FFF",
                        height: "177px",
                      }}
                    >
                      <div style={{ textAlign: "left", paddingTop: "1rem" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <circle cx="20" cy="20" r="19.5" stroke="#21816A" />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="20"
                            viewBox="0 0 24 20"
                            fill="none"
                            x="8"
                            y="11"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <g clip-path="url(#clip0_136_356)">
                              <path
                                d="M5.4 0C6.19565 0 6.95871 0.316071 7.52132 0.87868C8.08393 1.44129 8.4 2.20435 8.4 3C8.4 3.79565 8.08393 4.55871 7.52132 5.12132C6.95871 5.68393 6.19565 6 5.4 6C4.60435 6 3.84129 5.68393 3.27868 5.12132C2.71607 4.55871 2.4 3.79565 2.4 3C2.4 2.20435 2.71607 1.44129 3.27868 0.87868C3.84129 0.316071 4.60435 0 5.4 0ZM19.2 0C19.9956 0 20.7587 0.316071 21.3213 0.87868C21.8839 1.44129 22.2 2.20435 22.2 3C22.2 3.79565 21.8839 4.55871 21.3213 5.12132C20.7587 5.68393 19.9956 6 19.2 6C18.4044 6 17.6413 5.68393 17.0787 5.12132C16.5161 4.55871 16.2 3.79565 16.2 3C16.2 2.20435 16.5161 1.44129 17.0787 0.87868C17.6413 0.316071 18.4044 0 19.2 0ZM0 11.2013C0 8.9925 1.7925 7.2 4.00125 7.2H5.6025C6.19875 7.2 6.765 7.33125 7.275 7.56375C7.22625 7.83375 7.20375 8.115 7.20375 8.4C7.20375 9.8325 7.83375 11.1188 8.8275 12H0.79875C0.36 12 0 11.64 0 11.2013ZM15.1988 12H15.1725C16.17 11.1188 16.7963 9.8325 16.7963 8.4C16.7963 8.115 16.77 7.8375 16.725 7.56375C17.235 7.3275 17.8013 7.2 18.3975 7.2H19.9988C22.2075 7.2 24 8.9925 24 11.2013C24 11.6438 23.64 12 23.2013 12H15.1988ZM8.4 8.4C8.4 7.44522 8.77929 6.52955 9.45442 5.85442C10.1295 5.17929 11.0452 4.8 12 4.8C12.9548 4.8 13.8705 5.17929 14.5456 5.85442C15.2207 6.52955 15.6 7.44522 15.6 8.4C15.6 9.35478 15.2207 10.2705 14.5456 10.9456C13.8705 11.6207 12.9548 12 12 12C11.0452 12 10.1295 11.6207 9.45442 10.9456C8.77929 10.2705 8.4 9.35478 8.4 8.4ZM4.8 18.1987C4.8 15.4388 7.03875 13.2 9.79875 13.2H14.2013C16.9613 13.2 19.2 15.4388 19.2 18.1987C19.2 18.75 18.7537 19.2 18.1987 19.2H5.80125C5.25 19.2 4.8 18.7537 4.8 18.1987Z"
                                fill="#21816A"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_136_356">
                                <rect width="24" height="19.2" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </svg>
                        <div style={{ color: "#1F342F" }}>
                          <div style={{ fontSize: "20px" }}>600,000+</div>
                          <div style={{ fontSize: "14px" }}>
                            Therapist & Mental Health Professionals
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{ paddingTop: "1em" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        padding: "10px",
                        border: "1px solid #21816A",
                        backgroundColor: "#FFF",
                        height: "177px",
                      }}
                    >
                      <div style={{ textAlign: "left", paddingTop: "1rem" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <circle cx="20" cy="20" r="19.5" stroke="#21816A" />

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            x="7"
                            y="7"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <path
                              d="M14.6906 1.54223C15.9094 1.78598 16.7016 2.97192 16.4578 4.19067L16.35 4.72504C16.1016 5.97661 15.6422 7.16723 15 8.25004H21.75C22.9922 8.25004 24 9.25786 24 10.5C24 11.3672 23.5078 12.1219 22.7859 12.4969C23.2969 12.9094 23.625 13.5422 23.625 14.25C23.625 15.3469 22.8375 16.261 21.8016 16.4579C22.0078 16.8 22.125 17.1985 22.125 17.625C22.125 18.6235 21.4734 19.4719 20.5734 19.7625C20.6062 19.9172 20.625 20.0813 20.625 20.25C20.625 21.4922 19.6172 22.5 18.375 22.5H13.8047C12.9141 22.5 12.0469 22.2375 11.3062 21.7454L9.50156 20.5407C8.25 19.7063 7.5 18.3 7.5 16.7954V11.5829C7.5 10.2141 8.12344 8.92504 9.1875 8.06723L9.53437 7.79067C10.7766 6.79692 11.625 5.40004 11.9344 3.84379L12.0422 3.30942C12.2859 2.09067 13.4719 1.29848 14.6906 1.54223ZM1.5 9.00004H4.5C5.32969 9.00004 6 9.67036 6 10.5V21C6 21.8297 5.32969 22.5 4.5 22.5H1.5C0.670312 22.5 0 21.8297 0 21V10.5C0 9.67036 0.670312 9.00004 1.5 9.00004Z"
                              fill="#21816A"
                            />
                          </svg>
                        </svg>
                        <div style={{ color: "#1F342F" }}>
                          <div style={{ fontSize: "20px" }}>200,000+</div>
                          <div style={{ fontSize: "14px" }}>
                            Satisfied Customers
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{ paddingTop: "1em" }}>
                    <div
                      style={{
                        borderRadius: "10px",
                        padding: "10px",
                        border: "1px solid #21816A",
                        backgroundColor: "#FFF",
                        height: "177px",
                      }}
                    >
                      <div style={{ textAlign: "left", paddingTop: "1rem" }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                        >
                          <circle cx="20" cy="20" r="19.5" stroke="#21816A" />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="23"
                            viewBox="0 0 20 23"
                            fill="none"
                            x="10"
                            y="9"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <g clip-path="url(#clip0_138_534)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M4.28486 1.42831C4.28486 0.638275 4.92313 0 5.71317 0C6.50321 0 7.1415 0.638275 7.1415 1.42831V2.85664H12.8548V1.42831C12.8548 0.638275 13.493 0 14.2831 0C15.0731 0 15.7114 0.638275 15.7114 1.42831V2.85664H17.8539C19.0367 2.85664 19.9963 3.81628 19.9963 4.99911V7.14159H-0.00012207V4.99911C-0.00012207 3.81628 0.959524 2.85664 2.14235 2.85664H4.28483V1.42831H4.28486ZM19.9964 8.5699V20.7106C19.9964 21.8934 19.0367 22.853 17.8539 22.853H2.14238C0.959557 22.853 -8.99332e-05 21.8934 -8.99332e-05 20.7106V8.5699H19.9964ZM8.41544 20.0626C8.52614 20.0626 8.60291 20.0126 8.64576 19.9126L8.99391 19.077H10.815L11.1632 19.9126C11.206 20.0126 11.2828 20.0626 11.3935 20.0626C11.4685 20.0626 11.5274 20.0393 11.5702 19.9929C11.6131 19.9465 11.6345 19.8894 11.6345 19.8215C11.6345 19.793 11.6256 19.7573 11.6077 19.7144L10.2419 16.49C10.2169 16.4329 10.1794 16.382 10.1294 16.3373C10.0794 16.2927 10.0134 16.2704 9.93124 16.2704H9.87768C9.79913 16.2704 9.73396 16.2927 9.68218 16.3373C9.63041 16.382 9.59203 16.4329 9.56702 16.49L8.2012 19.7144C8.18335 19.7573 8.17441 19.793 8.17441 19.8215C8.17441 19.8894 8.19584 19.9465 8.23869 19.9929C8.28154 20.0393 8.34046 20.0626 8.41544 20.0626ZM9.18138 18.6325L9.90446 16.8917L10.6275 18.6325H9.18138ZM5.24994 20.0358H7.39777C7.46204 20.0358 7.5165 20.0144 7.56113 19.9715C7.60577 19.9287 7.62808 19.8751 7.62808 19.8108C7.62808 19.7465 7.60577 19.6921 7.56113 19.6475C7.5165 19.6028 7.46204 19.5805 7.39777 19.5805H5.49632V18.3914H7.20495C7.26922 18.3914 7.32368 18.37 7.36831 18.3272C7.41295 18.2843 7.43526 18.2307 7.43526 18.1665C7.43526 18.1022 7.41295 18.0477 7.36831 18.0031C7.32368 17.9585 7.26922 17.9362 7.20495 17.9362H5.49632V16.7524H7.39777C7.46204 16.7524 7.5165 16.731 7.56113 16.6882C7.60577 16.6453 7.62808 16.5918 7.62808 16.5275C7.62808 16.4632 7.60577 16.4088 7.56113 16.3641C7.5165 16.3195 7.46204 16.2972 7.39777 16.2972H5.24994C5.1821 16.2972 5.12497 16.3213 5.07854 16.3695C5.03212 16.4177 5.00891 16.4757 5.00891 16.5435V19.7948C5.00891 19.8626 5.03212 19.9197 5.07854 19.9661C5.12497 20.0126 5.1821 20.0358 5.24994 20.0358ZM2.78073 20.0626C2.84859 20.0626 2.90572 20.0393 2.95213 19.9929C2.99856 19.9465 3.02176 19.8894 3.02176 19.8215V18.4557L4.30725 16.6614C4.33582 16.615 4.3501 16.5668 4.3501 16.5168C4.35368 16.4489 4.33314 16.3909 4.2885 16.3427C4.24387 16.2945 4.18584 16.2704 4.11443 16.2704C4.02516 16.2704 3.95374 16.3114 3.90018 16.3936L2.78073 18.0219L1.66129 16.3936C1.60773 16.3114 1.53632 16.2704 1.44704 16.2704C1.3792 16.2704 1.32296 16.2945 1.27832 16.3427C1.2337 16.3909 1.21137 16.4489 1.21137 16.5168C1.21137 16.5668 1.22566 16.615 1.25422 16.6614L2.53435 18.4557V19.8215C2.53435 19.8894 2.55845 19.9465 2.60666 19.9929C2.65486 20.0393 2.71289 20.0626 2.78073 20.0626ZM12.6629 20.0626C12.7308 20.0626 12.7888 20.0393 12.837 19.9929C12.8852 19.9465 12.9093 19.8894 12.9093 19.8215V18.5789H14.018C14.2215 18.5789 14.3796 18.6173 14.492 18.6941C14.6045 18.7708 14.6858 18.8681 14.7357 18.986C14.7857 19.1038 14.817 19.2234 14.8295 19.3448C14.842 19.4662 14.8482 19.5716 14.8482 19.6608V19.8215C14.8482 19.893 14.8705 19.951 14.9152 19.9956C14.9598 20.0402 15.0196 20.0626 15.0946 20.0626C15.1625 20.0626 15.2196 20.0393 15.266 19.9929C15.3124 19.9465 15.3356 19.8894 15.3356 19.8215V19.5751C15.3356 19.5002 15.3285 19.4029 15.3142 19.2832C15.2999 19.1636 15.2705 19.0395 15.2258 18.911C15.1812 18.7824 15.1143 18.6673 15.025 18.5655C14.9357 18.4637 14.8161 18.3932 14.6661 18.3539C14.9018 18.2718 15.0777 18.1415 15.1937 17.9629C15.3098 17.7844 15.3678 17.5916 15.3678 17.3845C15.3678 17.1774 15.3169 16.9926 15.2151 16.8301C15.1134 16.6676 14.9553 16.5382 14.7411 16.4418C14.5269 16.3454 14.2501 16.2972 13.9109 16.2972H12.6629C12.5951 16.2972 12.5379 16.3213 12.4915 16.3695C12.4451 16.4177 12.4219 16.4757 12.4219 16.5435V19.8215C12.4219 19.8894 12.4451 19.9465 12.4915 19.9929C12.5379 20.0393 12.5951 20.0626 12.6629 20.0626ZM12.9093 18.1183V16.7578H13.852C14.1162 16.7578 14.3233 16.7855 14.4733 16.8408C14.6233 16.8962 14.7286 16.9738 14.7893 17.0738C14.85 17.1738 14.8804 17.2898 14.8804 17.422C14.8804 17.6505 14.7884 17.8237 14.6045 17.9415C14.4206 18.0593 14.1787 18.1183 13.8788 18.1183H12.9093ZM17.4138 20.0893C17.6924 20.0893 17.9343 20.0447 18.1396 19.9554C18.3449 19.8662 18.5038 19.7421 18.6163 19.5832C18.7288 19.4243 18.785 19.2449 18.785 19.0449C18.785 18.8414 18.744 18.6762 18.6618 18.5494C18.5797 18.4227 18.4708 18.3209 18.3351 18.2441C18.1994 18.1674 18.0512 18.1058 17.8905 18.0593C17.7299 18.0129 17.5692 17.971 17.4085 17.9335C17.2478 17.896 17.0996 17.854 16.9639 17.8076C16.8282 17.7612 16.7193 17.6987 16.6372 17.6201C16.5551 17.5416 16.514 17.4362 16.514 17.3041C16.514 17.1042 16.6051 16.9524 16.7872 16.8488C16.9693 16.7453 17.196 16.6935 17.4674 16.6935C17.6317 16.6935 17.7861 16.7069 17.9307 16.7337C18.0753 16.7605 18.2083 16.7953 18.3297 16.8381C18.344 16.8417 18.3583 16.8462 18.3726 16.8515C18.3869 16.8569 18.4012 16.8596 18.4154 16.8596C18.4833 16.8596 18.536 16.8355 18.5735 16.7873C18.6109 16.739 18.6297 16.6882 18.6297 16.6346C18.6297 16.5703 18.6145 16.5221 18.5842 16.49C18.5538 16.4578 18.519 16.4346 18.4797 16.4204C18.3369 16.3668 18.1762 16.3239 17.9977 16.2918C17.8191 16.2597 17.6245 16.2436 17.4138 16.2436C17.1139 16.2436 16.8604 16.2936 16.6533 16.3936C16.4462 16.4936 16.2899 16.6266 16.1846 16.7926C16.0793 16.9587 16.0266 17.1416 16.0266 17.3416C16.0266 17.5309 16.0677 17.6871 16.1498 17.8103C16.2319 17.9335 16.3408 18.0344 16.4765 18.1129C16.6122 18.1915 16.7604 18.2548 16.9211 18.3031C17.0818 18.3513 17.2433 18.395 17.4058 18.4343C17.5683 18.4736 17.7174 18.5164 17.853 18.5628C17.9887 18.6092 18.0977 18.6673 18.1798 18.7369C18.2619 18.8065 18.303 18.8985 18.303 19.0127C18.303 19.1663 18.2619 19.2886 18.1798 19.3796C18.0977 19.4707 17.9861 19.535 17.845 19.5725C17.704 19.61 17.5442 19.6287 17.3656 19.6287C17.1371 19.6287 16.9345 19.6055 16.7577 19.5591C16.5809 19.5127 16.4319 19.4627 16.3105 19.4091C16.2783 19.3948 16.2444 19.3877 16.2087 19.3877C16.1409 19.3877 16.0873 19.41 16.048 19.4546C16.0087 19.4993 15.9891 19.5519 15.9891 19.6126C15.9891 19.6591 16.0043 19.7028 16.0346 19.7439C16.065 19.7849 16.0998 19.8144 16.1391 19.8322C16.2962 19.9001 16.481 19.9599 16.6934 20.0117C16.9059 20.0634 17.146 20.0893 17.4138 20.0893ZM10.1428 14.7332C10.4178 14.7332 10.6534 14.6787 10.8498 14.5698C11.0462 14.4609 11.198 14.3145 11.3051 14.1306C11.4122 13.9467 11.4658 13.7423 11.4658 13.5173C11.4658 13.2602 11.414 13.0379 11.3105 12.8505C11.2069 12.663 11.0632 12.5175 10.8793 12.4139C10.6954 12.3104 10.482 12.2586 10.2392 12.2586C9.94642 12.2586 9.71254 12.3086 9.53756 12.4086C9.3626 12.5085 9.23048 12.6157 9.14121 12.7299C9.14835 12.6085 9.16799 12.4702 9.20012 12.3148C9.23226 12.1595 9.2885 12.0086 9.36884 11.8622C9.44919 11.7158 9.56167 11.5953 9.70628 11.5007C9.8509 11.4061 10.0375 11.3588 10.266 11.3588C10.4124 11.3588 10.5454 11.3739 10.665 11.4043C10.7847 11.4346 10.8891 11.4712 10.9784 11.5141C11.0069 11.5248 11.0373 11.5302 11.0694 11.5302C11.1373 11.5302 11.1908 11.5078 11.2301 11.4632C11.2694 11.4186 11.289 11.3677 11.289 11.3106C11.289 11.2177 11.2515 11.1534 11.1766 11.1177C11.0694 11.0606 10.94 11.0079 10.7882 10.9597C10.6365 10.9115 10.4499 10.8874 10.2285 10.8874C9.93571 10.8874 9.68933 10.9472 9.48936 11.0668C9.2894 11.1865 9.12961 11.3436 9.00998 11.5382C8.89037 11.7328 8.80467 11.9417 8.75288 12.1649C8.70111 12.388 8.67522 12.605 8.67522 12.8156C8.67522 12.962 8.68415 13.1218 8.702 13.295C8.71986 13.4682 8.75646 13.6387 8.8118 13.8065C8.86715 13.9744 8.94838 14.1288 9.05551 14.2698C9.16263 14.4109 9.30457 14.5234 9.48132 14.6073C9.65808 14.6912 9.87858 14.7332 10.1428 14.7332ZM10.1482 14.2779C9.92679 14.2779 9.74824 14.2315 9.61255 14.1386C9.47687 14.0458 9.3751 13.9244 9.30725 13.7744C9.23941 13.6244 9.19299 13.4637 9.16799 13.2923C9.20727 13.2209 9.2653 13.1397 9.34206 13.0486C9.41884 12.9576 9.52507 12.8772 9.66076 12.8076C9.79645 12.738 9.96964 12.7032 10.1803 12.7032C10.4481 12.7032 10.6481 12.7781 10.7802 12.9281C10.9123 13.0781 10.9784 13.2709 10.9784 13.5066C10.9784 13.6423 10.9445 13.769 10.8766 13.8869C10.8088 14.0047 10.7132 14.0993 10.5901 14.1708C10.4669 14.2422 10.3196 14.2779 10.1482 14.2779Z"
                                fill="#21816A"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_138_534">
                                <rect
                                  width="20"
                                  height="22.8602"
                                  fill="white"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </svg>
                        <div style={{ color: "#1F342F" }}>
                          <div style={{ fontSize: "20px" }}>6</div>
                          <div style={{ fontSize: "14px" }}>
                            Years in Business
                          </div>
                          <br></br>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={styles.search}
                  style={{ padding: "20px 0", textAlign: "center" }}
                >
                  <InputSmartSearch
                    placeholder="Enter your City / Zip"
                    onSelectPlace={handleSelectPlace}
                    maxLength={200}
                    max={200}
                    withButton
                    buttonClass={styles.bottomSBtn}
                    className={styles.searchInput}
                    buttonLabel="CONNECT - GET ESA NOW"
                    onButtonClick={() => {
                      setGlobalState({ prevPage: window.location.pathname });
                      checkRedirect();
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )) || <FooterLanding></FooterLanding>}
    </div>
  );
};
